module.exports = "<div class=\"container\">\r\n  <h2>Plenary speakers</h2>\r\n  <app-speaker\r\n    *ngFor=\"let participant of participants\"\r\n    [participant]=\"participant\"\r\n    class=\"d-inline-block\r\n            col-xl-4\r\n            col-md-8\r\n            spaces\r\n              \"\r\n  ></app-speaker>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/plenary-speakers/plenary-speakers.component.html
// module id = ../../../../../src/app/main/plenary-speakers/plenary-speakers.component.html
// module chunks = main